import React from 'react'
import ym from 'react-yandex-metrika'

import { baseURL, baseURLImage } from '../../../../api/api'
import { ReactComponent as Arrow } from '../../../../assets/images/icons/apartment-arrow.svg'
import { ReactComponent as Brush } from '../../../../assets/images/icons/brush.svg'
import { formatNumberWithThousands } from '../../../../helpers/common'
import { LayoutItemType } from '../../../../store/layouts/types'
import style from './ApartmentCard.module.scss'

const ApartmentCard = ({
  projectName,
  UF_IMAGE2D,
  UF_STUDIO,
  UF_AREA,
  UF_ROOMS,
  UF_READY_QUARTER,
  isReady,
  UF_PRICE,
  UF_SQUARE_PRICE,
  UF_RENOVATION,
  UF_KORPUS,
  UF_FLOOR,
  UF_URL,
  UF_BUILD_YEAR,
}: LayoutItemType) => {
  const name = `
      ${UF_STUDIO === '1' ? `Студия ${UF_AREA}` : ''}
      ${UF_ROOMS === '1' && UF_STUDIO !== '1' ? `1 комната ${UF_AREA}` : ''}
      ${Number(UF_ROOMS) > 1 ? `${UF_ROOMS} комнаты ${UF_AREA}` : ''}
    `

  return (
    <a
      href={UF_URL ? UF_URL : '#'}
      target='_blank'
      className={style.ApartmentCard}
      onClick={() => {
        ym('reachGoal', 'client link', {
          'client link': {
            'apartment layouts click': {
              [projectName]: `${name.trim()} м2`,
            },
          },
        })
      }}
    >
      <img
        src={`${
          UF_IMAGE2D?.includes('//')
            ? UF_IMAGE2D
            : `${baseURLImage}${UF_IMAGE2D}`
        }`}
        alt=''
      />
      <div className={style['ApartmentCard__info-wrapper']}>
        <h3>
          {name}м<sup>2</sup>
        </h3>
        <div className={style.ApartmentCard__row}>
          <div
            className={`${style.ApartmentCard__col} ${style['ApartmentCard__col--1']}`}
          >
            <span>{`
              ${UF_KORPUS ? UF_KORPUS : ''}
              ${UF_FLOOR ? `, этаж ${UF_FLOOR}` : ''}
            `}</span>
            <span>
              {isReady === 'Y'
                ? 'Готовая квартира'
                : `Заселение до ${UF_READY_QUARTER} ${UF_BUILD_YEAR}`}
            </span>
          </div>
          <div
            className={`${style.ApartmentCard__col} ${style['ApartmentCard__col--2']}`}
            style={{ marginRight: 0 }}
          >
            <div
              className={`${style.ApartmentCard__col} ${style['ApartmentCard__col--3']}`}
            >
              <span>Стоимость</span>
              <span>Цена за м2</span>
            </div>
            <div
              className={`${style.ApartmentCard__col} ${style['ApartmentCard__col--4']}`}
            >
              <span>
                <b>от {UF_PRICE && formatNumberWithThousands(UF_PRICE)} ₽</b>
              </span>
              <span>
                <b>
                  от{' '}
                  {UF_SQUARE_PRICE &&
                    formatNumberWithThousands(UF_SQUARE_PRICE)}{' '}
                  ₽
                </b>
              </span>
            </div>
          </div>
          <div
            className={`${style.ApartmentCard__col} ${style['ApartmentCard__col--5']}`}
          >
            <span>
              <Brush />
              {UF_RENOVATION === 'Без отделки'
                ? `${UF_RENOVATION}`
                : `${UF_RENOVATION} отделка`}
            </span>
          </div>
        </div>
      </div>
      <div className={style.ApartmentCard__arrow}>
        <Arrow />
      </div>
    </a>
  )
}

export default ApartmentCard
